import React from 'react'
import moment from 'moment'
import { TableProps } from 'antd/lib/table'
import { ColumnProps } from 'src/components/Ant/Table'
import { currencyMask } from 'src/components/Formik'
import { R13Data } from 'src/store/ducks/reports/types'
import { Table, Text } from 'src/components/Ant'

const columns: ColumnProps<R13Data>[] = [
  {
    align: 'center',
    dataIndex: 'request_number',
    key: 'request_number',
    render: (value: string) => <Text>#{value}</Text>,
    title: 'web.report.13.table.report',
    width: 120
  },
  {
    align: 'center',
    render: (record: R13Data) => {
      let message = moment.utc(record?.started_on * 1000).format('DD/MM/YYYY')
      if (record.ended_on) {
        message = `${message}-${moment
          .utc(record?.ended_on * 1000)
          .format('DD/MM/YYYY')}`
      }

      return <Text>{message}</Text>
    },
    title: 'web.report.13.table.week'
  },
  {
    dataIndex: 'advance',
    ellipsis: true,
    key: 'advance',
    render: (value: number) => (
      <Text>{`BRL ${
        currencyMask({
          formatStr: true,
          value: value ?? 0
        }).maskedValue
      }`}</Text>
    ),
    title: 'common.ticket.type.advance',
    width: 120
  },
  {
    dataIndex: 'expenses',
    ellipsis: true,
    key: 'expenses',
    render: expenses => (
      <Text>{`BRL ${
        currencyMask({
          formatStr: true,
          value: expenses ?? 0
        }).maskedValue
      }`}</Text>
    ),
    title: 'common.ticket.type.expense',
    width: 120
  },
  {
    dataIndex: 'diff',
    ellipsis: true,
    key: 'diff',
    render: diff => {
      const style = {} as { color?: string }

      if (diff < 0) {
        style.color = 'rgba(2550, 0, 0, 0.65)'
      }

      return (
        <Text style={style}>{`BRL ${
          currencyMask({
            formatStr: true,
            value: diff ?? 0
          }).maskedValue
        }`}</Text>
      )
    },
    title: 'web.report.13.table.diff',
    width: 120
  }
]

function TableDetail({ ...props }: TableProps<R13Data>) {
  return (
    <Table
      {...props}
      className="table-striped table-sm"
      columns={columns}
      pagination={false}
    />
  )
}

export default TableDetail
